// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pictureList_text[data-v-c1987ac6] {\n  line-height: 0;\n  position: relative;\n  top: -10px;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
